import React, {Component} from 'react'
import PropTypes from 'prop-types'
import './style.css'
import NRTFormErrorMsg from "../FormErrorMsg"
import NRTColorPickerInput from "./ColorPickerInput"
import NRTFileInput from "./FileInput"
import NRTToggleSwitch from "./ToggleSwitchInput"
import NRTSelectInput from "./SelectInput"
import NRTRadioGroup from "./RadioGroup"
import TextInput from "./TextInput"
import NRTCpfCnpjInput from "./CpfCnpjInput"
import NRTCheckboxInput from "./CheckboxInput"
import NRTPhoneInput from "./PhoneInput"
import NRTCepInput from "./CEPInput"
import NRTTextArea from "./TextAreaInput"

import debounce from 'debounce'
import NRTNumberInput from "./NumberInput";

class NRTFormInput extends Component {

    initialState = {
        value: this.props.value,
        errorMsgs: [],
        showErrorMsgs: false,
        valid: false,
        modifiedCount: 0,
        resetCount: 0,
        validateCount: 0,
    }

    state = {}

    willUnmount = false


    componentWillMount() {
        this.reset()
    }


    componentWillUnmount() {

        this.willUnmount = true

        if (
            this.context.onInputRemoved &&
            this.props.name
        ) {
            this.context.onInputRemoved(this.props.name)
        }


    }


    componentWillReceiveProps(nextProps, context) {


        if (this.state.validateCount !== context.validateCount) {
            // chamou metodo validate no state manager

            this.setState(
                {
                    validateCount: context.validateCount,
                    errorMsgs: [],
                    modifiedCount: this.state.modifiedCount + 1
                },
                () => {
                    this.validate(this.state.value)
                })
        }


        if (this.state.resetCount !== context.resetCount)
            this.reset(context.resetCount)

        if (this.props.value !== nextProps.value)
            this.handleChange(nextProps.value)

    }


    reset(resetCount) {
        this.setState({
                ...this.initialState,
                resetCount: resetCount || 0,
                validateCount: this.state.validateCount || this.initialState.validateCount,
            },
            () => {
                this.handleChange(this.props.value)
            })

    }


    setValue = async (value) => {
        await this.handleChange(value, true)
    }

    handleChange = async (value, triggeredByOtherComponent = false) => {

        const {modifiedCount} = this.state

        //aceita o valor inicial
        if (this.props.disabled && modifiedCount !== 0)
            return

        // checa beforeChange antes de alterar valor
        if (this.props.beforeChange(value) === false)
            return


        this.setState(
            {
                value,
                modifiedCount: modifiedCount + 1,
                callAttention: triggeredByOtherComponent,
                errorMsgs: await this.getInputErrorMsgs(value),
                showErrorMsgs: false,
            },
            () => {
                this.props.onChange(this.props.name, value)
                this.notifyStateManager()


                this.showErrorMsgs()
            })

    }

    showErrorMsgs = debounce(() => {
        this.setState({showErrorMsgs: true})
    }, 1000)


    notifyStateManager() {
        this.context.onInputChange &&
        this.context.onInputChange(
            this.props.name,
            this.state.value,
            this.state.modifiedCount !== 1,
            this.state.errorMsgs.length === 0
        )
    }


    onFocus = () => {
        if (this.props.disabled)
            return false
    }

    onLabelClick = () => {
        //!this.props.label.startsWith('Ordenar') && this.input.focus()
    }

    async getInputErrorMsgs(value) {
        const validationResults = await Promise.all(
            this.props.validators.map(
                async validator => await validator(value)
            )
        )

        return validationResults.filter(result => !!result)
    }


    validate = async value => {

        const errorMsgs = await this.getInputErrorMsgs(value)

        this.setState(
            {
                errorMsgs
            },
            () => this.notifyStateManager()
        )
    }


    resolveInputType(type) {

        return {
            'radiogroup': NRTRadioGroup,
            'checkbox': NRTCheckboxInput,
            'color': NRTColorPickerInput,
            'file': NRTFileInput,
            'switch': NRTToggleSwitch,
            'select': NRTSelectInput,
            'cnpj': NRTCpfCnpjInput,
            'cpf': NRTCpfCnpjInput,
            'phone': NRTPhoneInput,
            'cep': NRTCepInput,
            'number': NRTNumberInput,
            'textarea': NRTTextArea,

        }[type] || TextInput

    }


    render() {

        const {
            errorMsgs,
            showErrorMsgs,
            modifiedCount,
            callAttention

        } = this.state

        const {
            name,
            label,
            type,
            customClass = ' ',
            style

        } = this.props


        const disabledCls = this.props.disabled ? ' disabled ' : ' '
        const errorCls = (showErrorMsgs && errorMsgs.length > 0 && modifiedCount > 1)
            ? ' error ' : ' '
        const callAttentionCls = callAttention ? ' blink ' : ' '

        const InputComponent = this.resolveInputType(type)
        return (

            <div className={'nrt-form-input ' + callAttentionCls + customClass + errorCls + disabledCls}
                 style={{
                     ...style,
                     display: type === 'hidden' ? 'none' : 'block',
                 }}
            >
                {
                    label &&
                    <label
                        htmlFor={name}
                        onClick={this.onLabelClick}
                    >
                        {label}
                    </label>
                }

                {
                    React.cloneElement(
                        <InputComponent/>,
                        {
                            ref: (node) => {
                                this.input = node
                            },
                            value: this.state.value,
                            onChange: value => this.handleChange(value),
                            onBlur: () => this.handleChange(this.state.value),
                            onFocus: this.onFocus,
                            name: this.props.name,
                            disabled: this.props.disabled,
                            ...this.props.customProps,
                        }
                    )
                }

                <div className={'error-msgs'}>
                    {
                        modifiedCount > 1 &&
                        showErrorMsgs &&
                        errorMsgs.map((msg, i) =>
                            <NRTFormErrorMsg key={name + 'err' + i} msg={msg}/>
                        )
                    }
                </div>
            </div>
        )
    }
}


NRTFormInput.contextTypes = {
    onInputChange: PropTypes.func,
    onInputRemoved: PropTypes.func,
    resetCount: PropTypes.number,
    validateCount: PropTypes.number,
}


NRTFormInput.propTypes = {
    name: PropTypes.any,
    value: PropTypes.any,
    label: PropTypes.string,
    placeHolder: PropTypes.string,
    validators: PropTypes.array,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    beforeChange: PropTypes.func,
    type: PropTypes.string,
    customClass: PropTypes.string,
    customProps: PropTypes.object,
    style: PropTypes.object,
}

NRTFormInput.defaultProps = {
    value: '',
    validators: [],
    defaultValue: '',
    disabled: false,
    onChange: () => null,
    onClick: () => null,
    beforeChange: () => true,
    type: 'text',
    customProps: {},
    style: {},
}

export default NRTFormInput



// WEBPACK FOOTER //
// ./src/components/_common/_form/FormInput/index.js